import CheckIcon from "@mui/icons-material/Check";
import { Chip, type ChipProps, Stack } from "@mui/material";
import { EnumPaperCandidateChallengeActionStatusFilter } from "./logics";

const SELECTED_PROPS = {
  color: "primary",
  icon: <CheckIcon />,
} as const satisfies Partial<ChipProps>;

export interface IPaperCandidateChallengeActionsFiltersProps {
  statusFilter: EnumPaperCandidateChallengeActionStatusFilter | null;
  setStatusFilter: (status: EnumPaperCandidateChallengeActionStatusFilter | null) => void;
}

export const PaperCandidateChallengeActionsFilters = ({
  statusFilter,
  setStatusFilter,
}: IPaperCandidateChallengeActionsFiltersProps) => {
  return (
    <Stack sx={{ flexDirection: "row", gap: 1, pt: 2 }}>
      <Chip
        label="Toutes"
        clickable
        onClick={() => setStatusFilter(null)}
        {...(statusFilter === null && SELECTED_PROPS)}
      />
      <Chip
        label="À réaliser"
        clickable
        onClick={() => setStatusFilter(EnumPaperCandidateChallengeActionStatusFilter.TODO)}
        {...(statusFilter === EnumPaperCandidateChallengeActionStatusFilter.TODO && SELECTED_PROPS)}
      />
      <Chip
        label="Déjà réalisées"
        clickable
        onClick={() => setStatusFilter(EnumPaperCandidateChallengeActionStatusFilter.DONE)}
        {...(statusFilter === EnumPaperCandidateChallengeActionStatusFilter.DONE && SELECTED_PROPS)}
      />
      <Chip
        label="Manquées"
        clickable
        onClick={() => setStatusFilter(EnumPaperCandidateChallengeActionStatusFilter.MISSED)}
        {...(statusFilter === EnumPaperCandidateChallengeActionStatusFilter.MISSED && SELECTED_PROPS)}
      />
      <Chip
        label="En retard"
        clickable
        onClick={() => setStatusFilter(EnumPaperCandidateChallengeActionStatusFilter.LATE)}
        {...(statusFilter === EnumPaperCandidateChallengeActionStatusFilter.LATE && SELECTED_PROPS)}
      />
    </Stack>
  );
};
